import { render, staticRenderFns } from "./TableDialog.vue?vue&type=template&id=d2b1c684&"
import script from "./TableDialog.vue?vue&type=script&lang=js&"
export * from "./TableDialog.vue?vue&type=script&lang=js&"
import style0 from "./TableDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports